"use client";
import React from "react";
// import { DestinationHero } from "@/components/destinations/DestinationHero";
// import AllDestinations, { destinationList } from "./AllDestinations";
import AllDestinations from "./AllDestinations";

const DestinationLayout = () => {
  return (
    <div>
      {/* <DestinationHero
        images={destinationList.map((x) => `/images/destination-images/${x.url}.webp`)}
        title="Choose the Cruise Destinations That Call to You"
      /> */}
      <AllDestinations />
    </div>
  );
};

export default DestinationLayout;
